import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './EmptyStateBox.css';
import Label from '../foundations/Label';
import Tooltip from '../molecules/Tooltip';

export default function EmptyStateBox({
    title = '',
    image = [],
    Icon,
    imageStyle = {},
    onClick = () => {},
    disabled = false,
}) {
    return (
        <Tooltip disabled={!disabled} titleTranslationKey="STATIC.PAGES.DATA_DESTINATIONS.UNAVAILABLE" distance={-25}>
            <div
                className={classnames(css.boxContainer, { [css.disabledBoxContainer]: disabled })}
                onClick={disabled ? undefined : onClick}
            >
                <Label text={title} className={css.boxTitle} />
                <div className={css.imagesContainer}>
                    {Icon ? (
                        <Icon style={imageStyle} className={css.boxImage} />
                    ) : (
                        image.map((path, index) => {
                            return (
                                <Fragment key={path}>
                                    {index ? <span className={css.imagesSeparator} /> : null}
                                    <img src={path} style={imageStyle} className={css.boxImage} />
                                </Fragment>
                            );
                        })
                    )}
                </div>
            </div>
        </Tooltip>
    );
}

EmptyStateBox.propTypes = {
    title: PropTypes.string,
    image: PropTypes.arrayOf(PropTypes.string),
    Icon: PropTypes.func,
    imageStyle: PropTypes.objectOf(PropTypes.any),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};
